import { translations } from '../translations/translations';
import type { Language } from '../types/translations';

export const boomiNavigationMenuLinks = (language: Language) => ({
    platform: [
        {
            title: translations[language].BOOMI_HEADER_home,
            icon: 'Home',
            link: 'https://boomi.com',
        },
        {
            title: translations[language].BOOMI_HEADER_discover,
            icon: 'Market place',
            link: 'https://discover.boomi.com/browse-solutions',
        },
    ],
    products: [
        {
            title: translations[language].BOOMI_HEADER_integration_title,
            icon: 'Integration',
            link: 'https://platform.boomi.com/AtomSphere.html',
        },
        {
            title: translations[language].BOOMI_HEADER_data_hub_title,
            icon: 'Hub',
            link: 'https://platform.boomi.com/MdmSphere.html',
        },
        {
            title: translations[language].BOOMI_HEADER_api_management_title,
            icon: 'API Management',
            link: 'https://platform.boomi.com/ApiSphere.html',
        },
        {
            title: translations[language].BOOMI_HEADER_flow_title,
            icon: 'Flow',
            link: 'https://flow.boomi.com/',
        },
        {
            title: translations[language].AUTOMATE_title,
            icon: 'Task Automation',
            link: 'https://taskautomation.boomi.com/',
        },
        {
            title: translations[language].BOOMI_HEADER_event_streams_title,
            icon: 'Event Streams',
            link: 'https://platform.boomi.com/EventStreams.html',
        },
    ],
    labs: [
        {
            title: translations[language].BOOMI_HEADER_spaces_title,
            link: 'https://boomi.com/boomi-labs/#spaces',
        },
        {
            title: translations[language].BOOMI_HEADER_bundles_title,
            link: 'https://platform.boomi.com/BoomiLabs.html#pub_bundles',
        },
        {
            title: translations[language].BOOMI_HEADER_integration_packs_title,
            link: 'https://platform.boomi.com/BoomiLabs.html#pub_ipacks',
        },
        {
            title: translations[language].BOOMI_HEADER_process_library_title,
            link: 'https://platform.boomi.com/BoomiLabs.html#pub_pl',
        },
        {
            title: translations[language].BOOMI_HEADER_connectors_title,
            link: 'https://platform.boomi.com/AtomSphere.html#settings',
        },
    ],
});
